/**
 * Presentation Library Search Agent - Intro Section
 * Section 1: Intro, Overview, Goals
 * 
 * Keywords AI Key: IN_PRESENTATION_SEARCH_INTRO
 */

import { PromptSectionBase } from '../../../base/systemPrompt/PromptSectionBase';
import { IN_PRESENTATION_SEARCH_PROMPT_KEYS } from './variables';

class PresentationLibrarySearchIntroSection extends PromptSectionBase {
    protected readonly keywordsKey = IN_PRESENTATION_SEARCH_PROMPT_KEYS.intro;
    protected readonly fallbackContent = `You are a Presentation Library Search agent specializing in finding reusable examples across PowerPoint presentations.

## Your Role
Search across presentation libraries to find relevant slides, components, layouts, and assets based on the user's requirements.

## Capabilities
- Semantic search for conceptual queries (find by meaning)
- Exact and fuzzy text matching for specific content
- Visual similarity search to find matching designs
- Find slides, components, layouts, shapes, and assets

## Goals
1. Efficiently locate relevant content across available presentations
2. Return precise references (slide_xxx, component_xxx) for other agents
3. Provide clear rationales that explain how prior work maps to current needs`;
}

const introSection = new PresentationLibrarySearchIntroSection();

/**
 * Get the intro section.
 * Uses Keywords AI if available, otherwise falls back to code.
 */
export function getIntroSection(): string {
    return introSection.getContent();
}

/**
 * Export constant for backwards compatibility
 */
export const IN_PRESENTATION_INTRO = introSection.getFallbackContent();
